import React from "react";
import * as echarts from "echarts";
import axios from "axios";

class SparkleCard extends React.Component {
  state = {
    updateData: [],
    money: "Loading...", // Placeholder until data is fetched
  };

  componentDidMount() {
    this.timeoutID = undefined;
    this.fetchData();
    this.chartPlace();
  }
  fetchData = async () => {
    try {
      // Initialize count variables
      let count = 0;
      let pendingCount = 0;
      let sparklineData = [];
  
      if (this.props.apiUrl.includes('users')) {
        // Handle paginated data
        let page = 1;
        const pageSize = 100;
        let totalPages = 1;
  
        while (page <= totalPages) {
          const response = await axios.get(`${this.props.apiUrl}?page=${page}&size=${pageSize}`);
          console.log(`API Response for page ${page}:`, response?.data);
  
          if (response?.data?.data?.users) {
            count += response.data.data.users.length;
            totalPages = response.data.data.totalPages || 1;
            page += 1;
          } else {
            console.error("Unexpected API response format:", response?.data);
            this.setState({ money: "Error loading data" });
            return;
          }
        }
      } else {
        // Handle non-paginated data
        const response = await axios.get(this.props.apiUrl);
  
        if (response?.data?.items) {
          pendingCount = response.data.items.filter(item => item.status === 'pending').length;
          count = pendingCount;
        } else if (response?.data?.events) {
          pendingCount = response.data.events.filter(item => item.status === 'pending').length;
          count = pendingCount;
        } else if (response?.data?.jobs) {
          pendingCount = response.data.jobs.filter(item => item.status === 'pending').length;
          count = pendingCount;
        } else if (response?.data?.sponsors) {
          pendingCount = response.data.sponsors.filter(item => item.status === 'pending').length;
          count = pendingCount;
        } else if (response?.data?.totalSelectedOptions !== undefined) {
          // Handle totalSelectedOptions count
          count = response.data.totalSelectedOptions;
        } else if (response?.data?.classifieds) {
          pendingCount = response.data.classifieds.filter(item => item.status === 'pending').length;
          count = pendingCount;
        }else if (Array.isArray(response?.data?.data)) {
          // Count all items in the data array
          count = response.data.data.length;
        }
        else {
          console.error("Unexpected API response format:", response?.data);
          this.setState({ money: "Error loading data" });
          return;
        }
      }
  
      // Generate random data for the chart
      sparklineData = Array.from({ length: 6 }, () => Math.random() * 10);
  
      this.setState({
        money: `${count} Items`, // Display the count of items
        updateData: sparklineData,
      }, () => {
        this.ploatData(this.state.updateData);
      });
  
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ money: "Error loading data" });
    }
  };
  
  
  
  
  
  

  ploatData = (data) => {
    var reData = data.map(() => Math.floor(Math.random() * 10) + 1);

    this.timeoutID = setTimeout(() => {
      this.ploatData(this.state.updateData);
      if (this.props.isRandomUpdate) {
        this.chartPlace();
      }
    }, 5000);

    this.setState({ updateData: reData });
  };

  chartPlace = () => {
    const { chartColor, index } = this.props;
    const { updateData } = this.state;

    var chartDom = document.getElementById("main" + index);
    var myChart = echarts.init(chartDom);

    var option = {
      tooltip: {
        trigger: "axis",
        formatter: function (value) {
          return value[0].data;
        },
      },
      grid: {
        left: 0,
        bottom: 0,
        top: 5,
        right: 0,
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          data: [0, 1, 2, 3, 4, 5],
        },
      ],
      yAxis: [
        {
          type: "value",
          splitLine: { show: false },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      series: [
        {
          type: "line",
          data: updateData,
          areaStyle: {
            color: chartColor || "#f79647",
          },
          itemStyle: {
            color: chartColor || "#f79647",
          },
          symbolSize: 1,
        },
      ],
    };

    option && myChart.setOption(option);
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  render() {
    const { Heading, PerText, ContainerClass, index } = this.props;
    const { money } = this.state;

    return (
      <div className={ContainerClass}>
        <div className="card overflowhidden number-chart">
          <div className="body">
            <div className="number">
              <h6>{Heading}</h6>
              <span>{money}</span>
            </div>
            {/* <small className="text-muted">{PerText}</small> */}
          </div>
          <div
            id={"main" + index}
            className="sparkline"
            style={{ width: "100%", height: 55 }}
          ></div>
        </div>
      </div>
    );
  }
}

export default SparkleCard;
